import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getTranslations} from '../../../utils/selectors';
import {pushAnalyticsEvent} from '../../organisms/Analytics';

function CancelationLink({
    cancellationUrl,
    cancellationLinkText,
    analytics
}) {
    const isWaitingForAnalytics = React.useRef(false);

    const handleCancellationLinkClick = event => {
        event.preventDefault();

        if (!analytics) {
            window.location = cancellationUrl;
        } else {
            if (isWaitingForAnalytics.current) {
                return;
            }
            const {interactionName, cardPaymentAction} = analytics;
            pushAnalyticsEvent({
                interactionName,
                cardPaymentAction,
                eventCallback: () => {
                    window.location = cancellationUrl;
                    isWaitingForAnalytics.current = false;
                },
                eventTimeout: 500
            });
            isWaitingForAnalytics.current = true;
        }
    };

    return (
        <a
            className="paymentform-nav-link"
            href={cancellationUrl}
            onClick={handleCancellationLinkClick}
        >
            <span className="icon-arrow-left" />
            <span className="paymentform-nav-link-text">{cancellationLinkText}</span>
        </a>
    );
}

CancelationLink.propTypes = {
    cancellationUrl: PropTypes.string.isRequired,
    cancellationLinkText: PropTypes.string.isRequired,
    analytics: PropTypes.shape({
        interactionName: PropTypes.string.isRequired,
        cardPaymentAction: PropTypes.string.isRequired
    })
};

CancelationLink.defaultProps = {
    analytics: {
        interactionName: 'card payment interaction',
        cardPaymentAction: 'change payment method'
    }
};

const mapStateToProps = state => {
    const translations = getTranslations(state);
    return {
        cancellationLinkText: translations.formHeader.cancellationLinkText
    };
};

export default connect(mapStateToProps)(CancelationLink);
